// Classifies a firestop image so views/PDFs can order and label them without
// relying on the file name. Set when the image is staged for upload.
export const FIRESTOP_IMAGE_TYPE = {
  // The blueprint with the firestop location marker (full, non-zoomed view).
  BLUEPRINT_LOCATION: 'BLUEPRINT_LOCATION',
  // The zoomed/cropped blueprint view around the marker. Reserved for a future
  // capture flow; nothing produces it yet.
  BLUEPRINT_LOCATION_ZOOMED: 'BLUEPRINT_LOCATION_ZOOMED',
  // A camera/added photo of the firestop itself (default).
  FIRESTOP_PHOTO: 'FIRESTOP_PHOTO',
};

// Blueprint/location images come before the firestop photos when displayed.
// Lower rank sorts first.
export const FIRESTOP_IMAGE_TYPE_ORDER = {
  [FIRESTOP_IMAGE_TYPE.BLUEPRINT_LOCATION]: 0,
  [FIRESTOP_IMAGE_TYPE.BLUEPRINT_LOCATION_ZOOMED]: 1,
  [FIRESTOP_IMAGE_TYPE.FIRESTOP_PHOTO]: 2,
};

// Rank used for ordering; unknown/legacy images fall in with the photos.
export const getFirestopImageTypeOrder = (firestopImage) => {
  const imageType = firestopImage?.imageType;
  return imageType in FIRESTOP_IMAGE_TYPE_ORDER
    ? FIRESTOP_IMAGE_TYPE_ORDER[imageType]
    : FIRESTOP_IMAGE_TYPE_ORDER[FIRESTOP_IMAGE_TYPE.FIRESTOP_PHOTO];
};
